import { jsPDF } from "jspdf";
import { applyPlugin } from "jspdf-autotable";
import { CellType } from "./types";
import { GetCoverSheetResponseType, FileOperate, ShowType, ProcedureSavedInChangeType } from "service/procedureList/types";
import { CoverSheetPreviewType } from "app/pages/previewFile";
const logoBase64 =
  "data:image/png;base64,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";

applyPlugin(jsPDF);

const headerStyle = {
  fillColor: "#95b3d7",
  textColor: "#ffffff",
  font: "Calibri-bold",
  fontStyle: "normal",
  fontSize: 8.4,
  lineWidth: 0.2,
  lineColor: "#1f4e78",
  cellPadding: { top: 1.1, bottom: 0.5, left: 0.5, right: 0.5 },
  halign: "center",
  valign: "bottom",
};

const keyStyle = {
  fillColor: "#dbe5f1",
  textColor: "#000",
  fontStyle: "normal",
  font: "Calibri",
  fontSize: 8.4,
  lineWidth: 0.2,
  lineColor: "#1f4e78",
  halign: "center",
  valign: "middle",
  cellPadding: { top: 1.2, bottom: 0.8, left: 0.5, right: 0.5 },
};

const valueStyle = {
  fillColor: "#ffffff",
  textColor: "#000",
  fontStyle: "normal",
  font: "Calibri",
  fontSize: 8.4,
  lineWidth: 0.2,
  lineColor: "#1f4e78",
  cellPadding: { top: 1.2, bottom: 0.8, left: 0.5, right: 0.5 },
  halign: "center",
  valign: "middle",
};

const margin = {
  top: 25,
  bottom: 25,
  left: 16,
  right: 16,
};

const firstPartInfo: CellType[][] = [
  [
    {
      content: "Task Information",
      colSpan: 4,
      styles: headerStyle,
    },
  ],
  [
    {
      content: "Account Name",
      styles: keyStyle,
    },
    {
      dataKey: "accountName",
      styles: valueStyle,
    },
    { content: "Account Code", styles: keyStyle },
    {
      dataKey: "accountAbbr",
      styles: valueStyle,
    },
  ],
  [
    {
      content: "Account Manager",
      styles: keyStyle,
    },
    {
      dataKey: "accountManager",
      styles: valueStyle,
    },
    { content: "Account Location", styles: keyStyle },
    {
      dataKey: "accountLocation",
      styles: valueStyle,
    },
  ],
  [
    {
      content: "Team Leader",
      styles: keyStyle,
    },
    {
      dataKey: "accountTeamLeader",
      styles: valueStyle,
    },
    { content: "Account Supervisor", styles: keyStyle },
    {
      dataKey: "accountSupervisor",
      styles: valueStyle,
    },
  ],
  [
    {
      content: "Task Label Name",
      styles: keyStyle,
    },
    {
      dataKey: "taskLabelName",
      styles: valueStyle,
    },
    { content: "Task ID", styles: keyStyle },
    {
      dataKey: "taskId",
      styles: valueStyle,
    },
  ],
  [
    {
      content: "Turnaround Time",
      styles: keyStyle,
    },
    {
      dataKey: "turnaroundTime",
      styles: valueStyle,
    },
    { content: "Highly Regulated?", styles: keyStyle },
    {
      dataKey: "highRegulatedName",
      styles: valueStyle,
    },
  ],
  [
    {
      content: "Procedure Information",
      colSpan: 4,
      styles: headerStyle,
    },
  ],
  [
    {
      content: "Primary Procedure Owner",
      styles: keyStyle,
    },
    {
      dataKey: "primaryProcedureOwner",
      styles: valueStyle,
    },
    { content: "Procedure Owner", styles: keyStyle },
    {
      dataKey: "procedureOwner",
      styles: valueStyle,
    },
  ],
  [
    {
      content: "Procedure Created by",
      styles: keyStyle,
    },
    {
      dataKey: "initiator",
      styles: valueStyle,
    },
    { content: "Procedure Create Date", styles: keyStyle },
    {
      dataKey: "createdTimeString",
      styles: valueStyle,
    },
  ],
  [
    {
      content: "Procedure Status",
      styles: keyStyle,
    },
    {
      dataKey: "procedureStatus",
      styles: valueStyle,
    },
    { content: "", styles: keyStyle },
    {
      content: "",
      styles: valueStyle,
    },
  ],
];

const generateCoverSheet = async (coverSheetData: GetCoverSheetResponseType) => {
  await Promise.all([import("./Calibri-normal"), import("./Calibri-bold-normal")]);
  const doc = new jsPDF({
    unit: "mm",
    format: "a4",
  });
  doc.setFont("Calibri", "normal");
  doc.setFont("Calibri-bold", "normal");
  doc.setLineHeightFactor(1.2);

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  doc.setFontSize(16.8);
  doc.setTextColor(0, 0, 0);
  const renderedPages = new Set<number>();
  const didDrawPage = () => {
    const currentPage = doc.getNumberOfPages();
    if (renderedPages.has(currentPage)) return;
    renderedPages.add(currentPage);

    doc.setFont("Calibri-bold", "normal");
    doc.setFontSize(13.6);
    doc.setTextColor(89, 89, 89);
    const confidentialText = "CONFIDENTIAL";
    const y = pageHeight - 0.7 - 16;
    const textWidth = doc.getTextWidth(confidentialText);
    const x = pageWidth - 16 - textWidth;
    doc.text(confidentialText, x, y, { baseline: "top" });
  };

  const text = "Cover Sheet";
  const textWidth = doc.getTextWidth(text);

  const textX = (pageWidth - textWidth) / 2;
  doc.text(text, textX, margin.top + 13, {});

  const lineY = margin.top + 13.6;
  doc.setLineWidth(0.5);
  doc.line(textX, lineY, textX + textWidth, lineY);

  const radio = 0.18666666666;
  doc.addImage(logoBase64, "PNG", margin.left + 1.6, margin.top + 6, 180 * radio, 43 * radio);

  const tableStartY = margin.top + 20;
  const tableWidth = pageWidth - margin.left * 2 - 2;
  const firstPartDataObj = { ...coverSheetData.taskInfo, ...coverSheetData.procedureInfo };
  // @ts-ignore
  doc.autoTable({
    startY: tableStartY,
    margin: {
      ...margin,
      left: margin.left + 1,
      right: margin.right + 1,
    },
    columnStyles: {
      0: { cellWidth: tableWidth * 0.23404255319 },
      1: { cellWidth: tableWidth * 0.2659574468 },
      2: { cellWidth: tableWidth * 0.23404255319 },
      3: { cellWidth: tableWidth * 0.2659574468 },
    },
    body: firstPartInfo.map((row) => {
      return row.map((cell) => {
        if ("dataKey" in cell) {
          const { dataKey, ...rest } = cell;
          return {
            content: String(firstPartDataObj[dataKey as keyof typeof firstPartDataObj] ?? ""),
            ...rest,
          };
        } else {
          return cell;
        }
      });
    }),
    styles: {
      overflow: "linebreak",
      cellWidth: "wrap",
    },
    didDrawCell: (data: any) => {
      if (data.cell.text.length === 0) {
        doc.text(data.cell.raw.content, data.cell.x + data.cell.width / 2, data.cell.y + data.cell.height / 2, { align: "center", baseline: "middle" });
      }
    },
    didDrawPage,
  });

  //shared task information part
  // @ts-ignore
  doc.autoTable({
    // @ts-ignore
    startY: doc.lastAutoTable.finalY,
    margin: {
      ...margin,
      left: margin.left + 1,
      right: margin.right + 1,
    },
    columnStyles: {
      0: { cellWidth: tableWidth * 0.23404255319 },
      1: { cellWidth: tableWidth * 0.2659574468 },
      2: { cellWidth: tableWidth * 0.23404255319 },
      3: { cellWidth: tableWidth * 0.2659574468 },
    },
    head: [
      [
        {
          content: "Shared Task Information",
          colSpan: 4,
          styles: {
            ...headerStyle,
          },
        },
      ],
    ],
    showHead: "everyPage",
    body: [
      [
        {
          content: "Shared Task(s)",
          styles: {
            ...keyStyle,
          },
        },
        {
          content: coverSheetData.shareTaskInfos.map(({ accountCode, taskId, taskLabelName }) => `${accountCode}-${taskId}-${taskLabelName}`).join(",\n"),
          colSpan: 3,
          styles: {
            ...valueStyle,
            halign: "left",
            cellPadding: { ...valueStyle.cellPadding, left: 2 },
          },
        },
      ],
    ],
    styles: {
      overflow: "linebreak",
      cellWidth: "wrap",
    },
    didDrawCell: (data: any) => {
      if (data.cell.text.length === 0) {
        doc.text(data.cell.raw.content, data.cell.x + data.cell.width / 2, data.cell.y + data.cell.height / 2 + 0.45, { align: "center", baseline: "middle" });
      }
    },

    didDrawPage,
  });
  // @ts-ignore
  let currentY = doc.lastAutoTable.finalY;
  let currentPoint = currentY;
  const linesToHeight = (x: number) => 3.556 * x + 2;
  const heightToLines = (y: number) => (y - 2) / 3.556;
  const headerHeight = 5.156;
  const columnNameHeight = linesToHeight(1);
  const remainingSpace = pageHeight - currentY - margin.bottom;
  //min header height is 2 header height + 1 line height
  const minheaderHeight = headerHeight + columnNameHeight + columnNameHeight;

  if (remainingSpace < minheaderHeight) {
    doc.addPage();
    currentY = margin.top;
  }

  //procedure change history part
  const header = [
    [
      {
        content: "Procedure Change History",
        colSpan: 5,
        styles: headerStyle,
      },
    ],
    [
      {
        content: "#",
        styles: keyStyle,
      },
      {
        content: "Approval Date",
        styles: keyStyle,
      },
      { content: "Revision Category", styles: keyStyle },
      {
        content: "Change",
        styles: keyStyle,
      },
      {
        content: "Approved by",
        styles: keyStyle,
      },
    ],
  ] as const;

  /**
   *
   * \u2022 means bullet point -> •
   * \u2009 means thin space ->
   */
  const getChangeColumnContent = (row: GetCoverSheetResponseType["changeHistories"][number]) => {
    const { changes, showType, procedureSavedInChangeType, isClientServerPathChange } = row;
    // calculate text container width (tableWidth * 13) / 32 - left padding - right padding
    const textContainerWidth = (tableWidth * 13) / 32 - 2 - 3.8;
    const procedureSavedInChange =
      procedureSavedInChangeType !== ProcedureSavedInChangeType.None &&
      doc
        .splitTextToSize(`${ProcedureSavedInChangeType[procedureSavedInChangeType]}`, textContainerWidth, {
          ...valueStyle,
          cellPadding: 0,
        })
        .map((text: string, idx: number) => (idx === 0 ? `\u2022   ${text}` : `\u2009\u2009\u2009\u2009\u2009\u2009${text}`))
        .join("\n");

    const clientServerPathChange = isClientServerPathChange && `\u2022   Changed Client Server Path`;

    const changeFilesContent = changes
      .map((i) => {
        const lines: string[] = doc.splitTextToSize(`${FileOperate[i.fileOperate]} - ${i.fileName}`, textContainerWidth, { ...valueStyle, cellPadding: 0 });
        return lines.map((text, idx) => (idx === 0 ? `\u2022   ${text}` : `\u2009\u2009\u2009\u2009\u2009\u2009${text}`)).join("\n");
      })
      .join("\n");

    if (showType === ShowType.NA && !procedureSavedInChange && !clientServerPathChange) {
      return "\u2022   N/A";
    }

    if (showType === ShowType.Archived) {
      return "\u2022   Archived all files";
    }

    return [procedureSavedInChange, clientServerPathChange, changeFilesContent].filter(Boolean).join("\n");
  };

  // @ts-ignore
  doc.autoTable({
    // @ts-ignore
    startY: currentY,
    margin: {
      ...margin,
      left: margin.left + 1,
      right: margin.right + 1,
    },
    columnStyles: {
      0: { cellWidth: (tableWidth * 1) / 32 },
      1: { cellWidth: (tableWidth * 4) / 32 },
      2: { cellWidth: (tableWidth * 9) / 32 },
      3: { cellWidth: (tableWidth * 13) / 32 },
      4: { cellWidth: (tableWidth * 5) / 32 },
    },
    head: header,
    showHead: "everyPage",
    body: [
      ...(coverSheetData.changeHistories.length > 0
        ? coverSheetData.changeHistories.map((row, index) => {
            const { approvalDate, approvedBy, revisionCategory } = row;
            return [
              {
                content: `${index + 1}`,
                styles: {
                  ...valueStyle,
                  overflow: "visible",
                },
              },
              {
                content: approvalDate,
                styles: {
                  ...valueStyle,
                },
              },
              {
                content: revisionCategory,
                styles: {
                  ...valueStyle,
                  overflow: "visible",
                },
              },
              {
                content: getChangeColumnContent(row),
                styles: {
                  ...valueStyle,
                  halign: "left",
                  cellPadding: { ...valueStyle.cellPadding, left: 2, right: 0 },
                },
              },
              {
                content: approvedBy,
                styles: {
                  ...valueStyle,
                  cellPadding: { ...valueStyle.cellPadding, left: 0.4, right: 0.4 },
                },
              },
            ];
          })
        : [
            Array.from({ length: 5 }, () => ({
              content: "",
              styles: valueStyle,
            })),
          ]),
    ],
    styles: {
      overflow: "linebreak",
      cellWidth: "wrap",
    },
    didParseCell: (data: any) => {
      const remainingSpace = pageHeight - currentPoint - margin.bottom;
      let column3Lines = [],
        column4Lines = [];
      if (data.section === "head") {
        if (data.cell.text[0] === header[0][0].content) {
          currentPoint += headerHeight;
        }
        if (data.cell.text[0] === header[1][0].content) {
          currentPoint += columnNameHeight;
        }
      } else if (data.section === "body" && data.column.index === 4) {
        const columnIndexMap = [1, 4, 9, 13, 5];
        const paddingMap = [0, 0, 0, 2, 0.4 + 0.4];
        column3Lines = data.row.cells[3].text;
        column4Lines = doc.splitTextToSize(data.row.cells[4].raw.content, (tableWidth * columnIndexMap[4]) / 32 - paddingMap[4] + 0.2, { ...valueStyle, cellPadding: 0 });
        const column3Height = linesToHeight(column3Lines.length);
        const column4Height = linesToHeight(column4Lines.length);
        currentPoint += Math.max(column3Height, column4Height);
      }
      const afterRowRemainingSpace = pageHeight - currentPoint - margin.bottom;

      if (afterRowRemainingSpace < 0) {
        const currentPageCanTakeRows = Math.max(Math.floor(heightToLines(remainingSpace)), 0);
        const nextPageColumn3Lines = column3Lines.length - currentPageCanTakeRows <= 0 ? column3Lines.length : column3Lines.length - currentPageCanTakeRows;
        const nextPageColumn4Lines = column4Lines.length - currentPageCanTakeRows <= 0 ? column4Lines.length : column4Lines.length - currentPageCanTakeRows;
        const nextPageCanTakeRows = Math.max(nextPageColumn3Lines, nextPageColumn4Lines);

        currentPoint = margin.top + headerHeight + columnNameHeight + linesToHeight(nextPageCanTakeRows);
        // some case it still is header, data.row.cells.length === 1(Procedure Change History)
        if (data.row.cells[3] && data.row.cells[4]) {
          data.row.cells[3].styles.minCellHeight = linesToHeight(nextPageColumn3Lines > currentPageCanTakeRows ? currentPageCanTakeRows : nextPageColumn3Lines);
          data.row.cells[4].styles.minCellHeight = linesToHeight(nextPageColumn4Lines > currentPageCanTakeRows ? currentPageCanTakeRows : nextPageColumn4Lines);
        }
      }
    },
    didDrawCell: (data: any) => {
      if (data.cell.text.length === 0) {
        const isNoWarpCell = data.column.index === 0;
        const availableWidth = data.cell.width - data.cell.styles.cellPadding.left - data.cell.styles.cellPadding.right;
        const lines = doc.splitTextToSize(data.cell.raw.content, availableWidth);
        const isCenter = data.cell.raw.styles.halign === "center";
        const textX = isCenter ? data.cell.x + data.cell.width / 2 : data.cell.x + data.cell.styles.cellPadding.left;
        const textTotalHeight = 3.5 * lines.length - 3.4;
        let textY = lines.length === 1 ? data.cell.y + data.cell.height / 2 : data.cell.y + data.cell.height / 2 - textTotalHeight / 2;
        if (isNoWarpCell) {
          textY = data.cell.y + data.cell.height / 2;
        }
        doc.text(data.cell.raw.content, textX, textY, {
          ...(isCenter && { align: "center" }),
          baseline: "middle",
          ...(!isNoWarpCell && { maxWidth: availableWidth }),
        });
      }
    },

    didDrawPage,
  });

  const blob = doc.output("blob");
  return blob;
};

const openPDFOnline = (blob: Blob) => {
  const blobUrl = URL.createObjectURL(blob);
  localStorage.setItem("previewLink", JSON.stringify({ url: blobUrl, fileName: "Cover Sheet.pdf", type: CoverSheetPreviewType }));
  window.open(`/PreviewFile`, "_blank", "noopener,noreferrer");
};

const downloadPDF = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { openPDFOnline, downloadPDF };
export default generateCoverSheet;
